import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

import createCache from '@emotion/cache';
import { BpkEmotionCacheContext } from '@skyscanner-internal/backpack-web/bpk-component-layout';

type EmotionCache = ReturnType<typeof createCache>;

let hadHydrationError = false;

export const markHydrationError = (): void => {
  hadHydrationError = true;
};

export const EmotionCacheProvider = ({ children }: { readonly children: ReactNode }) => {
  const [recoveryCache, setRecoveryCache] = useState<EmotionCache | null>(null);

  useEffect(() => {
    if (!hadHydrationError) return;

    hadHydrationError = false;
    const newCache = createCache({ key: 'css' });
    newCache.sheet.flush();
    newCache.inserted = {};
    // eslint-disable-next-line react-hooks/set-state-in-effect -- swap the cache after hydration recovery
    setRecoveryCache(newCache);
  }, []);

  return (
    <BpkEmotionCacheContext.Provider value={recoveryCache}>
      {children}
    </BpkEmotionCacheContext.Provider>
  );
};
